/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useLayoutEffect } from 'react';
import { findNav, setResponsiveNav, setResponsiveToggle } from '@aarhus-university/au-designsystem-delphinus/source/js/components/nav';
import {
  getDataLayerForReceipt,
  getDataLayerForViewApplicationsOverview,
  getDataLayerForVirtualPageview,
} from './gtm';

const useSetTitle = (title: string): void => {
  useEffect(() => {
    document.title = title;
  });
};

const useRemoveBackgroundCards = (main = true, postHeader = false): void => {
  useLayoutEffect(() => {
    if (main) {
      document.querySelector('main')?.classList.remove('theme--background-cards');
    }
    if (postHeader) {
      document.querySelector('.page__post-header')?.classList.remove('theme--background-cards');
    }
  });
};

const useGTM = (event: string, condition: boolean, payload: IGTMPayload): void => {
  window.dataLayer = window.dataLayer || [];
  useEffect(() => {
    let key = event;
    if (event === 'virtualPageview') {
      key = `${key}-${payload.pageTitle}`;
    }
    if (condition && !window.dataLayer.map((e) => e.key).includes(key)) {
      console.log(`GTM: ${event}`);
      if (event === 'ViewApplicationsOverview') {
        window.dataLayer.push({
          ...{ key, event },
          ...getDataLayerForViewApplicationsOverview(
            payload.applications as IApplication[],
            payload.applicant as IApplicant,
            payload.phase as number,
          ),
        });
      }

      if (event === 'virtualPageview') {
        window.dataLayer.push({
          ...{ key, event },
          ...getDataLayerForVirtualPageview(
            payload.pageUrl as string,
            payload.pageTitle as string,
            payload.lang as string,
          ),
        });
      }

      if (event === 'ViewReceipt') {
        window.dataLayer.push({
          ...{ key, event },
          ...getDataLayerForReceipt(
            payload.application as IApplication,
            payload.applicant as IApplicant,
          ),
        });
      }
    }
  });
};

let windowInnerWidth = 0;
const useSetResponsiveNavigation = (
  navElementsSelector: string,
  navSelector: string,
): any => useCallback((node: HTMLElement | null) => {
  if (node !== null) {
    const navElements = document.querySelectorAll(navElementsSelector);
    const navRef = findNav(node);
    setResponsiveNav(navElements, navRef);
    setResponsiveToggle(navElements);

    windowInnerWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (windowInnerWidth > 0 && window.innerWidth !== windowInnerWidth) {
        windowInnerWidth = window.innerWidth;
        setResponsiveNav(navElements, navRef);
      }
    });

    const nav = document.querySelector(navSelector);
    if (nav?.querySelector('.nav__item--active')) {
      nav.classList.add('nav--has-active-item');
    }
  }
}, []);

export {
  useSetTitle,
  useRemoveBackgroundCards,
  useGTM,
  useSetResponsiveNavigation,
};
